/**
 * Determines the display value for the summary table.
 * @param {*} val The value used in the formatting
 * @param {*} type The specific layer that's being considered (e.g. FDR)
 * @returns 
 */
export function getDisplayValue(val, type) {
    var displayVal = val
    if (type == 'FDR'){
        switch(val) {
            case '0':
                displayVal = 'None'
                break;
            case '1':
                displayVal = 'Mod'
                break;
            case '2':
                displayVal = 'High'
                break;
            case '3':
                displayVal = 'Ext'
                break;
            case '4':
                displayVal = 'Cat'
                break;
            default:
                displayVal = 'None'
                break;
          }
    } else if (type == 'Temp' || type == 'RH' || type == 'WindSpeed' || type == '2dp') {
        if (!isNaN(val)){
            // Round to 1 decimal place
            displayVal = Math.round(+val * 10) / 10
        }
    }
    return displayVal
}

/**
 * Determines the display value for the prescribed burn table
 * @param {*} p 
 * @returns 
 */
export function pbClass(p) {
    if (p == 1) {
        return "pb-wet";
    } else if (p == 2) {
        return "pb-poor";
    } else if (p == 3) {
        return "pb-marginal-low";
    } else if (p == 4) {
        return "pb-possible";
    } else if (p == 5) {
        return "pb-marginal-high";
    } else if (p == 6) {
        return "pb-outside";
    } else return "";
}

/**
 * Converts the wind direction value to points on a compass
 * https://en.wikipedia.org/wiki/Points_of_the_compass#:~:text=The%20half%2Dwinds%20are%20north,north%2Dnorthwest%20(NNW).
 * 
 * The compass point denotes where the wind (roughly) is coming from.
 * 
 * @param {*} d The wind direction (angle)
 * @returns The compass point (string)
 */
export function windCardinal(d) {
    if (d == -9999) {
        return "no-data";
    } else if (d > 348.75 || d <= 11.25) {
        return "N";
    } else if (d > 11.25 && d <= 33.75) {
        return "NNE";
    } else if (d > 33.75 && d <= 56.26) {
        return "NE";
    } else if (d > 56.26 && d <= 78.75) {
        return "ENE";
    } else if (d > 78.75 && d <= 101.25) {
        return "E";
    } else if (d > 101.25 && d <= 123.75) {
        return "ESE";
    } else if (d > 123.75 && d <= 146.25) {
        return "SE";
    } else if (d > 146.25 && d <= 168.75) {
        return "SSE";
    } else if (d > 168.75 && d <= 191.25) {
        return "S";
    } else if (d > 191.25 && d <= 213.75) {
        return "SSW";
    } else if (d > 213.75 && d <= 236.25) {
        return "SW";
    } else if (d > 236.25 && d <= 258.75) {
        return "WSW";
    } else if (d > 258.75 && d <= 281.25) {
        return "W";
    } else if (d > 281.25 && d <= 303.75) {
        return "WNW";
    } else if (d > 303.75 && d <= 326.25) {
        return "NW";
    } else if (d > 326.5 && d <= 348.75) {
        return "NNW";
    } else {
        return "NA";
    }
}